export default __webpack_public_path__ + "static/media/CustomSupport.b1ee0ff6.png";